/* import __COLOCATED_TEMPLATE__ from './dds-harmonics.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import type CircuitService from 'simdds/services/circuit';

const headerItemFunction = function (index: number): string {
  const header = [
    'harmonics.fundamental_images_label',
    'harmonics.second_harmonic_images_label',
    'harmonics.third_harmonic_images_label',
  ];
  return header[index] ?? 'harmonics.fundamental_images_label';
};

interface DDSHarmonicsSignature {
  Args: object;
  Element: HTMLDivElement;
}
export default class DDSHarmonicsPanel extends Component<DDSHarmonicsSignature> {
  @service declare circuit: CircuitService;
  headerItem = headerItemFunction;

  header = [
    'harmonics.fundamental_images_label',
    'harmonics.second_harmonic_images_label',
    'harmonics.third_harmonic_images_label',
  ];
  get showData() {
    return this.circuit.harmonicsData.rawHarmonicsTable.length > 0;
  }
  get showPPTSpur() {
    const hasCriticalError = this.circuit.hasCriticalError;
    const hasPPTSpur = this.circuit.pptSpur.PPTSpur1.hasPPTSpur;
    return hasPPTSpur && !hasCriticalError;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DdsHarmonics: typeof DDSHarmonicsPanel;
  }
}
